import { Dropdown } from 'primeng/dropdown';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { SaleOrder } from '../point-of-sale/domain/SaleOrder';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { ICompany } from 'app/shared/Domains/company';
import { IBranch } from 'app/shared/Domains/branch';

import { MessageService } from 'primeng/api';
import { Configuration } from 'config/config';

@Component({
  selector: 'app-quotations',
  templateUrl: './quotations.component.html',
  styleUrls: ['./quotations.component.css']
})
export class QuotationsComponent implements OnInit {
  @ViewChild("searchOrder", { static: false }) searchOrderInput: ElementRef;
  loading: boolean;
  user: IUser;
  saleOrder: SaleOrder;
  first: number = 0;
  tabIndex: number = 0;
  from: any;
  to: any;
  date: any;
  sales: any[];
  sourceSales: any[];
  company: ICompany;
  branch: IBranch;
  deliverySales: any[];
  sourceDeliverySales: any[];
  isData: boolean;
  configMemberPath: any;
  categoryOptions: any[] = [];
  selectedCategoryOption: any;
  orderStatus: string;
  confirmationMessage = '';
  private pendingConfirmationAction: (() => void) | null = null;
  constructor(
    private LanguageService: LanguageService,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private route: Router,
    private loader: NgxSpinnerService,
    public config: Configuration,
  ) {
    this.breadcrumbService.setItems([
      { label: 'Sales/Quotations' }
    ]);
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("QuotationsComponent", label);
  }
  ngOnInit() {
    var date = new Date();
    this.from = new Date(date.getFullYear(), date.getMonth(), 1);
    this.to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.user = AuthService.getLoggedInUser();
    this.saleOrder = new SaleOrder();
    this.orderStatus="quotation";
    this.getQuotations();
    this.sales = [];
    this.date = new Date();
    this.isData = false;
    this.company = new ICompany();
    this.branch = new IBranch();
    this.getCompany();
    this.getBranch();   
    this.configMemberPath = localStorage?.getItem('memberImagePath');
    this.categoryOptions = [{ label: "All", value: 'All' }];
    this.populateByCategory();
  }

  ngAfterViewInit() {
    this.searchOrderInput.nativeElement.focus();
    this.getQuotations();
  }
  getCompany() {
    this.company = AuthService.getLoggedInCompanyBranch();
    if (!this.company) {
      this.appServiceManager.get('companies/current').subscribe((res) => {
        if (res) {
          this.company = res;
        } else {
          this.company = new ICompany();
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
        (error) => {
          this.company = new ICompany();
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
    }
  }
  getBranch() {
    this.branch = AuthService.getLoggedInCurrentBranch();
    if (!this.branch) {
      this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
        if (res) {
          this.branch = res;
        } else {
          this.branch = new IBranch();
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
        (error) => {
          this.branch = new IBranch();
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
    }
  }
  getQuotations() {
    this.loading = true;
    this.loader.show();
    // Format dates as YYYY-MM-DD
    const formatDate = (d: Date) =>
      d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);

    const fromDateStr = formatDate(this.from);
    const toDateStr = formatDate(this.to);

    this.appServiceManager.get(`branches/${this.user.branch}/sale-orders/reports/by-filters/from/${fromDateStr}/to/${toDateStr}/status/${this.orderStatus}`).subscribe((res: any) => {
      if (res.length > 0) {
      }
      this.populateByCategory();
      this.sales = res.filter(x => x.status == 'POS');
      this.sourceSales = this.sales;
      this.sourceSales = this.sourceSales.sort((a, b) => { return <any>new Date(b.invoiceDate) - <any>new Date(a.invoiceDate) });
      this.deliverySales = res.filter(x => x.status != 'POS');
      this.sourceDeliverySales = this.deliverySales;
      this.isData = true;
      this.loading = false;
      this.loader.hide();
      this.isData = false;
      if (this.user.branch === '67f102774cf88446d8ce9929') {
        if (this.user.role === 'Pool Operator') {
          this.sales = this.sales.filter(item => item.category === 'Swimming items');
        }
        if (this.user.role === 'Bar Operator') {
          this.sales = this.sales.filter(item => item.category === 'Protien bar');
        }
        if (this.user.role === 'Spa Therapist') {
          this.sales = this.sales.filter(item => item.category === 'Spa Products');
        }
      }if (this.sales.length < 1) {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No SaleOrder Record Found' });
        this.isData = false;
      }
    },
      (error) => {
        this.loading = false;
        this.loader.hide();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  populateByCategory() {
    const existingCategories = new Set(this.categoryOptions.map(opt => opt.value));
    const uniqueNewCategories = new Set();
    this.sales.forEach((report) => {
      if (report.category && !existingCategories.has(report.category)) {
        uniqueNewCategories.add(report.category);
      }
    });
    const newOptions = Array.from(uniqueNewCategories).map((category) => ({
      label: category,
      value: category,
    }));

    this.categoryOptions = this.categoryOptions.concat(newOptions);
  }
  dropdownChange() {
    if (this.selectedCategoryOption && this.selectedCategoryOption !== 'All') {
      this.sales = this.sourceSales.filter(x => x.category === this.selectedCategoryOption);
      this.deliverySales = this.sourceDeliverySales.filter(x => x.category === this.selectedCategoryOption);
    } else {
      this.sales = Object.assign([], this.sourceSales);
      this.deliverySales = Object.assign([], this.sourceDeliverySales);
    }
    if (this.sales.length === 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
    }
  }
  handleTabChange(e) {
    var index = e.index;
    if (index == 0) {
      this.tabIndex = 0;
      this.clearSearchDeliveryOrders();
    }
    if (index == 1) {
      this.tabIndex = 1;
      this.clear();
    }

  }

  searchLocal(value, type) {
    let matchedNumber = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.sales = Object.assign([], this.sourceSales);
      }
      if (!value) {
        this.sales = Object.assign([], this.sourceSales);
      }
      if (value != "") {
        if (type === "number") {
          matchedNumber = Object.assign([], this.sourceSales).filter(
            cust => cust.invoiceNumber ? cust.invoiceNumber.indexOf(value) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedNumber;
        this.sales = source.filter(distinct);

        if (this.sales.length === 0) {
          this.sales = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.sales.length === 1) {
            this.first = 0;
          }
          this.sales = [...this.sales];
        }
      }
    } else {
      this.sales = Object.assign([], this.sourceSales);
      this.sales = [...this.sales];
    }
  }

  clear() {
    this.selectedCategoryOption = 'All';
    this.saleOrder = new SaleOrder();
    this.searchLocal("", "");
    this.first = 0;
    this.isData = false;
    const date = new Date();
    this.from = new Date(date.getFullYear(), date.getMonth(), 1);
    this.to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  searchLocalDeliveryOrders(value, type) {
    let matchedNumber = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.deliverySales = Object.assign([], this.sourceDeliverySales);
      }
      if (!value) {
        this.deliverySales = Object.assign([], this.sourceDeliverySales);
      }
      if (value != "") {
        if (type === "number") {
          matchedNumber = Object.assign([], this.sourceDeliverySales).filter(
            cust => cust.invoiceNumber ? cust.invoiceNumber.indexOf(value) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedNumber;
        this.deliverySales = source.filter(distinct);

        if (this.deliverySales.length === 0) {
          this.deliverySales = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.deliverySales.length === 1) {
            this.first = 0;
          }
          this.deliverySales = [...this.deliverySales];
        }
      }
    } else {
      this.deliverySales = Object.assign([], this.sourceDeliverySales);
      this.deliverySales = [...this.deliverySales];
    }
  }

  clearSearchDeliveryOrders() {
    this.saleOrder = new SaleOrder();
    this.searchLocalDeliveryOrders("", "");
    this.first = 0;
  }

  onPageChange(event) {
    this.first = event.first;
  }

  hotkeys($event) {
    if ($event.keyCode == 113) {
      this.route.navigateByUrl("/point-of-sale");

    }
  }

  confirmQuotation(order) {
    this.openConfirmationDialog("Are you sure you want to confirm this quotation?", () => {
      this.loading = true;
      this.appServiceManager.put('products/saleorders/confirmquotation/',{orderId: order._id}).subscribe(
          (res: any) => {
            if (res.status == true) {
              this.loading = false;
              this.messageService.clear();
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Quotation confirmed successfully.'});
              this.viewSaleOrder(order);
            } else {
              this.loading = false;
              this.messageService.clear();
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Error in quotation confirmation'});
            }  
          });
    });
  }

  viewSaleOrder(order) {
    this.route.navigateByUrl('point-of-sale/' + order._id);
  }
  getTotalSales(): number {
  
    return this.sales?.reduce((acc, cur) => acc + (cur.total || 0), 0) || 0;
}
CancelQuotation(order: { _id: string; }) {
  this.openConfirmationDialog("Are you sure you want to cancel this quotation?", () => {
    this.loading = true;
    this.appServiceManager.delete(`products/saleorders/cancelquotation/${order._id}`).subscribe(
        (res: any) => {
          if (res.status === true) {
            // Remove from local arrays
            this.sales = this.sales.filter(o => o._id !== order._id);
            this.sourceSales = this.sourceSales.filter(o => o._id !== order._id);
            this.deliverySales = this.deliverySales.filter(o => o._id !== order._id);
            this.sourceDeliverySales = this.sourceDeliverySales.filter(o => o._id !== order._id);
            //this.getSales(); // Refresh the sales list after deletion
            this.loading = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Quotation cancelled successfully.' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong in cancelling quotation' });
          }
        },
        (error) => {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        }
      );
  });
}

  private openConfirmationDialog(message: string, action: () => void): void {
    this.confirmationMessage = message;
    this.pendingConfirmationAction = action;
  }

  confirmPendingAction(): void {
    const action = this.pendingConfirmationAction;
    this.cancelPendingAction();
    action?.();
  }

  cancelPendingAction(): void {
    this.confirmationMessage = '';
    this.pendingConfirmationAction = null;
  }

 printAllInvoice(): void {
    let printContents, popupWin;
    let currentDate = new Date();
    this.branch.name = "Sales Report - " + this.branch.name + " - " + currentDate.getDate() + "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
    printContents = document.getElementById('allInvoice').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <html>
    <head>
    <title>${this.branch.name}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: bottom;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `
    );
  }


}